/* ==========================================================================
   Geo · Product card behaviour — wishlist + quick add.
   Uses event delegation on document, so it keeps working after the theme
   re-renders the grid (filtering, load more, infinite scroll).
   Upload to: assets/geo-product-card.js   (load with defer)
   ========================================================================== */

(function () {
  'use strict';

  var WKEY = 'geo:wishlist';

  function readWish() {
    try { return JSON.parse(localStorage.getItem(WKEY)) || []; } catch (e) { return []; }
  }
  function writeWish(v) {
    try { localStorage.setItem(WKEY, JSON.stringify(v)); } catch (e) {}
  }

  /* Paint the saved state onto every heart currently in the DOM. */
  function syncWish(scope) {
    var saved = readWish();
    var hearts = (scope || document).querySelectorAll('[data-geo-wish]');
    Array.prototype.forEach.call(hearts, function (b) {
      var on = saved.indexOf(b.getAttribute('data-geo-wish')) > -1;
      b.classList.toggle('is-on', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
  }

  var base = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root)
    ? window.Shopify.routes.root
    : '/';

  function broadcastCart() {
    return fetch(base + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        /* Generic event any script can listen for. */
        document.dispatchEvent(new CustomEvent('geo:cart:updated', { detail: cart }));

        /* Nudge the theme's own cart drawer/count if it exposes an event bus.
           Harmless when it doesn't — wrapped so a missing API can't break the add. */
        try {
          if (window.MinimogEvents && window.MinimogSettings && window.MinimogSettings.eventUpdateCart) {
            window.MinimogEvents.emit(window.MinimogSettings.eventUpdateCart, cart);
          }
        } catch (e) {}

        return cart;
      });
  }

  function quickAdd(btn) {
    var id = btn.getAttribute('data-geo-add');
    var label = btn.textContent;

    btn.classList.add('is-busy');

    fetch(base + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] })
    })
      .then(function (r) {
        if (!r.ok) throw new Error('add failed');
        return broadcastCart();
      })
      .then(function () {
        btn.textContent = btn.getAttribute('data-added-label') || 'ADDED';
        setTimeout(function () { btn.textContent = label; }, 1600);
      })
      .catch(function () {
        btn.textContent = 'TRY AGAIN';
        setTimeout(function () { btn.textContent = label; }, 1600);
      })
      .then(function () { btn.classList.remove('is-busy'); });
  }

  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;

    var w = e.target.closest('[data-geo-wish]');
    if (w) {
      e.preventDefault();
      var handle = w.getAttribute('data-geo-wish');
      var list = readWish();
      var i = list.indexOf(handle);
      if (i > -1) { list.splice(i, 1); } else { list.push(handle); }
      writeWish(list);
      /* Same product can appear more than once on a page, so repaint them all. */
      syncWish();
      return;
    }

    var q = e.target.closest('[data-geo-add]');
    if (q && !q.disabled) {
      e.preventDefault();
      quickAdd(q);
    }
  });

  function init() {
    syncWish();

    /* Re-paint after the grid is swapped out by filtering / pagination. */
    if ('MutationObserver' in window) {
      var target = document.querySelector('[data-product-container]') || document.body;
      var t;
      new MutationObserver(function () {
        clearTimeout(t);
        t = setTimeout(function () { syncWish(); }, 120);
      }).observe(target, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function () { syncWish(); });
})();
